import React from "react";
import Typewriter from "typewriter-effect";
import { AiFillGithub } from "react-icons/ai";
import { HiDownload } from "react-icons/hi";
import pdf from "../../Assets/Resume.pdf";

function HeroSection() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-grid" aria-hidden="true" />

      <div className="hero-content">
        {/* Available badge */}
        <div className="hero-tag">
          <span className="hero-tag-dot" />
          Available for work
        </div>

        {/* Greeting */}
        <p className="hero-greeting">
          Hi there! <span className="wave" role="img" aria-label="wave">👋</span>
        </p>

        {/* Name */}
        <h1 className="hero-name">
          I'm{" "}
          <span className="hero-name-accent">Muhammad<br />Muaaz</span>
        </h1>

        {/* Typewriter — role / title strings only */}
        <div className="hero-typewriter">
          <Typewriter
            options={{
              strings: [
                "Full-Stack Developer",
                "Software Engineer",
                "MERN Stack Developer",
                "React Developer",
                "Backend Engineer",
                "Open Source Contributor",
                "Problem Solver & Builder",
              ],
              autoStart: true,
              loop: true,
              deleteSpeed: 40,
              delay: 65,
            }}
          />
        </div>

        {/* Description */}
        <p className="hero-desc">
          I build fast, scalable web applications — from pixel-perfect frontends
          to robust backend APIs. Based in Lahore, Pakistan, crafting digital
          experiences that matter.
        </p>

        {/* Actions */}
        <div className="hero-actions">
          <a href={pdf} target="_blank" rel="noreferrer" className="btn-primary-custom">
            <HiDownload /> Download CV
          </a>
          <a
            href="https://github.com/MuhammadMuaaz007"
            target="_blank"
            rel="noreferrer"
            className="btn-outline-custom"
          >
            <AiFillGithub /> GitHub
          </a>
        </div>
      </div>

      {/* ── Terminal widget (right side, hidden on mobile) ── */}
      <div className="hero-terminal" aria-hidden="true">
        <div className="terminal-titlebar">
          <span className="terminal-dot" style={{ background: "#ff5f57" }} />
          <span className="terminal-dot" style={{ background: "#ffbd2e" }} />
          <span className="terminal-dot" style={{ background: "#28ca41" }} />
          <span className="terminal-title">muaaz ~ portfolio</span>
        </div>
        <div className="terminal-body">
          <div><span className="t-prompt">❯ </span><span className="t-cmd">whoami</span></div>
          <div><span className="t-val">Muhammad Muaaz</span></div>

          <div style={{ marginTop: 10 }}>
            <span className="t-prompt">❯ </span><span className="t-cmd">cat developer.json</span>
          </div>
          <div><span className="t-comment">{"{"}</span></div>
          <div>&nbsp;&nbsp;<span className="t-key">"role"</span><span className="t-comment">: </span><span className="t-val">"Full-Stack Developer"</span>,</div>
          <div>&nbsp;&nbsp;<span className="t-key">"type"</span><span className="t-comment">: </span><span className="t-val">"Software Engineer"</span>,</div>
          <div>&nbsp;&nbsp;<span className="t-key">"focus"</span><span className="t-comment">: </span><span className="t-val">"Web &amp; AI Engineering"</span>,</div>
          <div>&nbsp;&nbsp;<span className="t-key">"location"</span><span className="t-comment">: </span><span className="t-val">"Lahore, PK"</span>,</div>
          <div>&nbsp;&nbsp;<span className="t-key">"open_to_work"</span><span className="t-comment">: </span><span className="t-val">true</span></div>
          <div><span className="t-comment">{"}"}</span></div>

          <div style={{ marginTop: 10 }}>
            <span className="t-prompt">❯ </span><span className="t-cursor" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
